<template>
  <div id="app">
    <div class="container">
        <div class="columns">
          <div class="col-12">
    
              
              <HelloWorld msg="Welcome to Your Vue.js App"/>
  

        </div>
    
    </div>
  </div>
  </div>
</template>

<script>
import HelloWorld from './components/main.vue'
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import "../node_modules/vue-select/src/scss/vue-select.scss";

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style lang="scss">
  // @import '@/scss/base.scss';
  $primary-color: #3cb1bb;
  @import '../node_modules/vue-datetime/dist/vue-datetime.css';
  @import "../node_modules/spectre.css/src/spectre";
  @import "../node_modules/spectre.css/src/spectre-exp";
  @import "../node_modules/spectre.css/src/spectre-icons";
  $border: 1px solid rgba(223, 219, 219, 0.877);
  html,body {
    background-color: #F2F2F2;
  
  }

  .table {
        margin-top: 2em;
        border-top: $border;
        border-bottom: $border;
        
        tr {
          padding-top: .5em;
          padding-bottom: .5em;
        }
        td {
          border: none;
          padding-top: 1.5rem;
          padding-bottom: 1.5rem;
        }
      }
.wrapper-listado {
  padding: 1rem;
  background-color: white;
  .border-wrap {
    border: $border;
  }
  .listado-header {
    padding: 0.5rem;
    background-color: #f2f2f2;
    border: $border;
    .accion-listado {
      display: flex;

      flex-direction: row-reverse;

      .action {
        margin: 0;
        margin-top: 2em;
        a, a:visited, span, i {
        margin-left: 5px;
        font-size: 1.2em;
        color: $primary-color
        }
        
      }
    }
  }
}

.wrapper-form {
  background-color: white;
 
  margin-top: 2em;
  padding-bottom: 1em;
  .form-title {
    display: block;
    border-bottom: 1px solid black;
    div {
      margin-left: 1em;
      padding-top: .5em;
      font-size: 2em;
      padding-bottom: 5px;
    }
  }
  .form-wrapper {
    padding: 1em;
    .btn.btn-primary {
      // color: 
    }
  }
}

.vdatetime-popup__header {
  background: $primary-color;
}
.vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
  background: $primary-color;
}
.vdatetime-time-picker__item--selected{
  color: $primary-color;
}

.vdatetime-input {
  @extend .form-input;
}
</style>
